<template>
    <div class="imaged-item imaged-card-body text-center">
        <a v-if="reference != null" :href="reference" class="imaged-item-href">
            <img class="mx-auto d-block image-link-image" :src="image" :alt="description">
            <h3 class="card-title image-link-title">{{ name }}</h3>
            <p class="card-text image-link-description"> {{ description }}</p>
        </a>
        <!-- If no reference exists, only present text -->
        <div v-else class="imaged-item-href">
            <img class="img-fluid rounded mx-auto d-block image-link-image" :src="image" :alt="description">
            <h3 class="card-title image-link-title">{{ name }}</h3>
            <p class="card-text image-link-description"> {{ description }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ImagedLink",
        props: {
            name: String,
            description: String,
            image: String,
            reference: String
        }
    }
</script>

<style scoped>

    /**
    Margins between the links
     */
    .imaged-card-body {
        background-color: unset;
        color: rgb(227, 227, 227);
        width: 18rem;
        margin: 2rem 5%;
    }

    /**
    font for the title
     */
    .image-link-title {
        font-family: Norican,serif;
    }

    /**
    Remove href decorations for the links!
     */
    .imaged-item-href {
        display: block;
        color: inherit;
        text-decoration: none;
    }

    /**
    Remove href decorations for the links!
     */
    .imaged-item-href:visited, .imaged-item-href:hover, .imaged-item-href:active {
        color: inherit;
    }

    /**
    Font settings for the description
     */
    .image-link-description {
        font-family: Cambo,serif;
    }

    /**
    Hard set the image size so they are all the same!
     */
    .image-link-image {
        width: 8rem;
        height: 8rem;
    }
</style>